import { yupResolver } from "@hookform/resolvers/yup";
import { Close } from "@mui/icons-material";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ICustomDialogProps } from "../interfaces/dialog";
import CustomForm from "./CustomForm";

export const CustomDialog = (props: ICustomDialogProps) => {
  const {
    close,
    confirm,
    title,
    children,
    type,
    closeButtonLabel,
    confirmButtonLabel,
    formProps,
    open
  } = props;

  const { t } = useTranslation();

  const formMethods = useForm({
    resolver: formProps?.validationSchema ? yupResolver(formProps.validationSchema) : undefined,
    values: formProps?.initialValues,
  });

  useEffect(() => {
    if (open)
      formMethods.reset();
  }, [open])

  return (
    type === "form" && formProps ?
      <Dialog open={open} fullWidth scroll="paper">
        <FormProvider {...formMethods}>
          <form onSubmit={formMethods.handleSubmit(
            (data: any) => {
              formProps?.submit(data);
              close();
            },
          )
          }>
            <DialogTitle sx={{ fontWeight: 600 }}>
              {t(title)}
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={close}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <Close />
            </IconButton>
            <DialogContent sx={{ py: 0 }}>
              <CustomForm {...formProps} />
            </DialogContent>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                py: 2,
                px: 3,
              }}
            >
              <Button
                aria-label="close"
                variant="outlined"
                onClick={() => { formMethods.reset(); close(); }}
              >
                {closeButtonLabel}
              </Button>
              <Button
                type="submit"
                variant="contained"
              >
                {confirmButtonLabel}
              </Button>
            </Box>
          </form>
        </FormProvider>
      </Dialog>
      :
      type === "confirm" ?
        <Dialog scroll="paper" open={open} disableScrollLock>
          <DialogTitle sx={{ fontWeight: 600 }}>
            {t(title)}
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={close}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Close />
          </IconButton>
          <DialogContent sx={{ py: 0 }}>
            {children}
          </DialogContent>
          <DialogActions
            sx={{
              display: "flex",
              justifyContent: "space-between",
              py: 2,
              px: 3,
            }}
          >
            <Button
              variant="outlined"
              onClick={close}
            >
              {closeButtonLabel}
            </Button>
            <Button
              variant="contained"
              onClick={confirm}
              autoFocus
            >
              {confirmButtonLabel}
            </Button>
          </DialogActions>
        </Dialog>
        :
        <Dialog scroll="paper" open={open} disableScrollLock>
          <DialogTitle sx={{ fontWeight: 600 }}>
            {t(title)}
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={close}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Close />
          </IconButton>
          <DialogContent sx={{ pt: 0 }}>
            {children}
          </DialogContent>
        </Dialog>
  );
};
